export function normalizeGeoCoordinate(value: number, decimalPlaces = 6): number {
  if (!Number.isFinite(value)) {
    return value;
  }

  return Number(value.toFixed(decimalPlaces));
}
